import { useAppSelector } from "../../../services/redux/hooks/use-selector";
import {
  selectFileConfig,
  selectFilesValue,
  selectIsFileLoading,
} from "../redux/selectors";
import { TFilePreviewerActions } from "../types";
import { useCallback } from "react";
import { useAppDispatch } from "../../../services/redux/hooks/use-dispatch";
import { downloadArtifactAction } from "../redux/actions";

export const useFilePreviewer = () => {
  const dispatch = useAppDispatch();
  const fileValue = useAppSelector(selectFilesValue);
  const fileConfig = useAppSelector(selectFileConfig);
  const isFileLoading = useAppSelector(selectIsFileLoading);
  const handleFilePreviewerActions = useCallback(
    (type: TFilePreviewerActions) => {
      switch (type) {
        case "zoom": {
          console.log("ZOOM WILL BE HERE");
          return;
        }
        case "download": {
          dispatch(downloadArtifactAction());
          return;
        }
        case "center": {
          console.log("CENTER WILL BE HERE");
          return;
        }
        default:
          return;
      }
    },
    [fileValue?.userfiles.hash],
  );

  return { fileValue, fileConfig, isFileLoading, handleFilePreviewerActions };
};
